import React, {Component} from 'react'
import RowBoxItem from "./RowBoxItem";


class RowBoxItemContainer extends Component {
    render() {
        const {items: itemsFba, isPrivate, onRefresh, box, showDelete, onSelected, arrSelected, onCheckAll, incompleteMap} = this.props

        return (
            <tbody>
            {itemsFba.map((itemFba, indexFba) => {
                return (
                    <RowBoxItem
                        onRefresh={onRefresh}
                        key={itemFba._id}  index={indexFba}
                        isPrivate={isPrivate}
                        box={box}
                        showDelete={showDelete}
                        item={itemFba}
                        arrSelected={arrSelected}
                        onSelected={onSelected}
                        onCheckAll={onCheckAll}
                        incompleteMap={incompleteMap}
                    />
                )
            })}
            </tbody>
        )
    }
}

export default RowBoxItemContainer
